import React, {useContext} from 'react';
import {Button, Paper} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import Modal from '../common/Modal';
import {useListFacilities} from 'hooks/lists';
import {fetchQuizQuestions, deleteQuestion} from 'api/question';
import QuestionForm from './QuestionForm';
import QuestionTable from './QuestionTable';

const useListStyles = withStyles({
  information: {
    padding: 20,
  },
});

const QuestionList = useListStyles(({classes, ...restProps}) => {
  const {quizId} = restProps;

  const {
    tableState,
    refreshTable,
    selectPage,
    selectItemsPerPage,
    changeFilter,
    changeSorter,
    changeExtraFilters,
    modalOpen,
    currentRecord,
    openModal,
    closeModal,
    triggerSoftRefresh,
    deleteRecord,
  } = useListFacilities({
    fetchRecords: (props, signal) => fetchQuizQuestions({quizId, ...props}, signal),
    deleteFn: deleteQuestion,
    deletionSuccessMsg: 'The question has been successfully deleted!',
  });

  return (
    <div>
      <Modal
        title={currentRecord ? 'Update Question' : 'Create Question'}
        onClose={closeModal}
        open={modalOpen}
        maxWidth="sm"
        renderContent={() => (
          <QuestionForm
            initialValues={currentRecord}
            onCancel={closeModal}
            onSubmitSuccess={triggerSoftRefresh}
            quizId={quizId}
          />
        )}
      />
      <div className="container content-box">
        <Paper className={classes.information}>
          <h3 className="section-header">
            <div className="section-title">Question List</div>
            <Button variant="contained" color="primary" className="pull-right" onClick={() => openModal()}>
              Create Question
            </Button>
          </h3>
          <QuestionTable
            {...{
              tableState,
              refreshTable,
              selectPage,
              selectItemsPerPage,
              changeFilter,
              changeSorter,
              changeExtraFilters,
              showUpdateModal: openModal,
              onDeleteActionClick: deleteRecord,
            }}
          />
        </Paper>
      </div>
    </div>
  );
});

export default QuestionList;
